<div>
  <img class="error" src="assets/icons/error.svg" alt="error" />
  <app-onboarding-header
    title="Se cerró tu sesión"
    subtitle="La sesión del usuario ha finalizado, vuelve a ingresar para continuar utilizando la plataforma."
  ></app-onboarding-header>
</div>
